import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { environment } from '../environments/environment';
import { Logger } from '@nsalaun/ng-logger';

@Injectable({
    providedIn: 'root'
})
export class FirebaseAppCheckService {
    constructor(private logger: Logger) {
        this.initAppCheck();
    }

    private initAppCheck() {
        const app = initializeApp(environment.firebaseConfig);

        // Enable debug token in localhost
        if (location.hostname === 'localhost') {
            (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
            this.logger.info('Firebase App Check localhost debug mode enabled');
        }

        initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider(environment.appCheckReCaptchaEnterpriseKey),
            isTokenAutoRefreshEnabled: true,
        });
        this.logger.info('Firebase App Check initialized with ReCaptcha Enterprise');
    }
}
